import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { studyFactorServices } from "../../../../../APIServices/CTMS/studyFactorServices";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsRandomizationSchemaServices } from "../../../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";

const UpdateSubject = ({ siteId, subjectId, getStudySiteSubjectList, Show, Hide, Title, setSubjectId, subjectSettings }) => {
  const [subjectRow, setSubjectRow] = useState("");
  const [subjectColumns, setSubjectColumns] = useState([]);
  const [randomizerName, setRandomizerName] = useState("");
  const [factors, setFactors] = useState([]);
  const [randomizerSchemaList, setRandomizerSchemaList] = useState([]);
  const [factorList, setFactorList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams()
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudySubjectColumnData = async (e) => {
    setLoader(true)
    let data = await studySubjectManagementServices.getStudySubjectColumnData("active", studyId, siteId);
    let finalColumn
    if (subjectSettings === "IWRS") {
      let filterColumn = (data?.data || []).filter(
        (item) =>
          item.blinded === "no"
      );
      finalColumn = filterColumn
    } else {
      let filterColumn = (data?.data || []).filter(
        (item) =>
          item.blinded === "no" &&
          !["SCREENID", "RANDOMNUMBER"].includes(item.columnName)
      );
      finalColumn = filterColumn
    }
    setSubjectColumns(finalColumn);
    setLoader(false)
  };

  const handleSubjectRowChange = (e, columnKey) => {
    setSubjectRow({
      ...subjectRow,
      [columnKey]: e.target.value,
    });
  };

  const handleFactorChange = (name, value, index) => {
    setFactors((prev) => {
      const updated = [...prev];
      updated[index] = { name, value };
      return updated;
    });
  };

  const updateStudySubjectRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Subject!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.mode = StudyMode;
        userData.studyId = studyId;
        if (subjectSettings === "IWRS") {
          userData.factors = factors;
        }
        userData.subjectRow = subjectRow
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
          Hide()
          setSubjectId("")
        }
        setButtonLoader(false)
      }
    });
  };

  const getAssigedFactorinSites = async (e) => {
    let data = await studyFactorServices.getAssigedFactorinSites(
      studyId,
      siteId
    );
    setFactorList(data?.data || []);
  };

  useEffect(() => {
    if (!(siteId === "no" || !siteId)) {
      getStudySubjectColumnData();
      getAssigedFactorinSites()
    }
  }, [siteId]);

  const getStudySingleSubjectRow = async () => {
    let data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, siteId, subjectId)
    setSubjectRow(data?.data?.row);
    setFactors(data?.data?.factors || [])
    setRandomizerName(data?.randomizationName)
  }

  const initializeData = async () => {
    if (!siteId || !subjectId) return;
    await getStudySingleSubjectRow();
  };

  useEffect(() => {
    initializeData();
  }, [siteId, subjectId]);

  function isRowDataComplete() {
    let subjectColumnData = (subjectSettings === "IWRS" || subjectSettings === "Auto") ? subjectColumns?.filter(item => !(item?.columnName === "SUBJECTID" || item?.columnName === "SCREENID" || item?.columnName === "RANDOMNUMBER")) : subjectColumns
    const requiredColumns = subjectColumnData.filter(
      item => item?.required === "yes"
    );
    if (requiredColumns?.length > 0) {
      return requiredColumns.every(col => {
        const key = col.columnName;
        return subjectRow?.hasOwnProperty(key) && subjectRow[key] !== "" && subjectRow[key] !== null && subjectRow[key] !== undefined;
      });
    } else {
      return false
    }
  }

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {loader ? (
            <PageLoader />
          ) : (
            <>
              {subjectColumns?.map((item, index) => (
                <Form.Group key={index} className="mb-2">
                  <Form.Label className="fw-bold mb-1">
                    {item?.columnLabel}
                    {item?.required === "yes" && (
                      <abbr title="Required" className="text-danger"> *</abbr>
                    )}
                  </Form.Label>
                  {item?.columnType === "dropdown" ?
                    <Form.Select
                      onChange={(e) => handleSubjectRowChange(e, item?.columnName)}
                      className="br3" style={{ fontSize: 12 }}>
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option index={i} selected={subjectRow?.[item?.columnName] === el?.option} value={el?.option}>{el?.option}</option>
                      ))}
                    </Form.Select>
                    : item?.columnType === "radio" ?
                      (item?.columnOption || [])?.map((el, i) => (
                        <Form.Check
                          key={i}
                          type="radio"
                          label={el?.option}
                          name={item?.columnName}
                          value={el?.option}
                          checked={subjectRow?.[item?.columnName] === el?.option}
                          onChange={(e) => handleSubjectRowChange(e, item?.columnName)}
                          className="br3"
                        />
                      ))
                      : item?.columnType === "date" ? (
                        <Form.Control
                          onChange={(e) =>
                            handleSubjectRowChange(e, item?.columnName)
                          }
                          value={subjectRow[item?.columnName] || ""}
                          className="br3"
                          max={new Date().toISOString().split("T")[0]}
                          placeholder={`Enter ${item?.columnLabel}`}
                          type={item?.columnType}
                        />
                      ) : (
                        <Form.Control
                          onChange={(e) =>
                            handleSubjectRowChange(e, item?.columnName)
                          }
                          value={subjectRow[item?.columnName] || ""}
                          className="br3"
                          placeholder={`Enter ${item?.columnLabel}`}
                          type={item?.columnType}
                        />)
                  }
                </Form.Group>
              ))}
              {subjectSettings === "IWRS" &&
                <>
                  {factorList?.map((item, index) => (
                    <Form.Group className="mb-2" key={index}>
                      <Form.Label className="fw-bold mb-1">
                        {item?.label}{" "}
                        <abbr title="Required" className="text-danger">
                          *
                        </abbr>
                      </Form.Label>
                      <Form.Select
                        value={factors[index]?.value || ""}
                        style={{ fontSize: 12 }}
                        disabled={(item?.factors || [])?.length === 0 || subjectRow?.SUBJECTID}
                        onChange={(e) =>
                          handleFactorChange(item?.name, e.target.value, index)
                        }
                        className="br3"
                      >
                        <option value="">Select {item?.label}</option>
                        {(item?.factors || []).map((subItem, subIndex) => (
                          <option key={subIndex} value={subItem?.factor}>
                            {subItem?.option}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  ))}
                </>
              }
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={buttonLoader || !siteId || !isRowDataComplete()}
            onClick={updateStudySubjectRowData}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Subject"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateSubject;
